import {Trans} from '@lingui/macro';
import React from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {OkCancelDialog} from '../../../../components/common/dialogs/okCancelDialog';

/*
 * Type.
 */

interface DiscardChangesDialogProps {
  onDiscard: Handler;
  onCancel: Handler;
}

/*
 * Style.
 */

const StyledHeadline = styled.h2`
  font-weight: ${fontWeights.normal};
  font-size: ${fontSizes.large};
  text-align: center;
`;

/*
 * Component.
 */

export const DiscardChangesDialog = ({onDiscard, onCancel}: DiscardChangesDialogProps) => (
  <OkCancelDialog
    title={<Trans id="rule-discard-changes-dialog-title">Unsaved Changes</Trans>}
    okButtonLabel={<Trans id="rule-discard-changes-dialog-confirm">Discard</Trans>}
    onOkClick={onDiscard}
    onRequestClose={onCancel}
  >
    <StyledHeadline>
      <Trans id="rule-discard-changes-dialog-message">You have unsaved changes, continue?</Trans>
    </StyledHeadline>
  </OkCancelDialog>
);
